import { customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_POLICY_PANEL_FIREWALL_ADAPTERS_TABLE } from '../../../../../../../../webcomponents.constants';
import { GzPolicyUiSettingsTableWebComponent } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/dataTable';
import { getTableColumns } from './grid-config';
import { FirewallNetworkAdapterItem } from '@nirvana/shared/dtos/types/policies/common';

@customElement(WEB_COMPONENT_POLICY_PANEL_FIREWALL_ADAPTERS_TABLE)
export class GzFirewallAdaptersTableWebComponent extends GzPolicyUiSettingsTableWebComponent<
  FirewallNetworkAdapterItem,
  FirewallNetworkAdapterItem
> {
  protected hasReorderRowAction = false;
  protected hasDeleteRowAction = false;
  protected columns = getTableColumns();
}
